import { render, staticRenderFns } from "./partone.vue?vue&type=template&id=238a9d07&scoped=true&"
import script from "./partone.vue?vue&type=script&lang=js&"
export * from "./partone.vue?vue&type=script&lang=js&"
import style0 from "./partone.vue?vue&type=style&index=0&id=238a9d07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a9d07",
  null
  
)

component.options.__file = "partone.vue"
export default component.exports